import React, { /* useMemo, */ /* useRef */ } from 'react';
import Capabilities from './Capabilities';
import {/*  ButtonUI, DefaultContent, Section,SectionTitle,  */ /* ImageMedia, MotionContent, */ Page, } from '../components/imports';
// import { img_earth } from '../assets';
// import { Link } from 'react-router-dom';
// import useLink from '../hooks/useLink';
// import { padStart } from 'lodash';
import { project } from '../data/data';
import { LetsWork } from './Home';
// import { DefisReleves } from '../components/DefisReleves';



const Expertise = () => {

  document.title = `EXPERTISE — ${project.website}`
  // const { lawwdMap } = useRef(null);
  return (
    <Page className={""}>
      {/*  <MotionContent imgRef={lawwdMap} height={"!h-[50vh] lg:!h-[80vh]"} className={"relative bg-dark"} translateRange={["0%", "-10%"]} >
        <ImageMedia src={img_earth} loading={"eager"} className="origin-bottom object-bottom !full !overflow-visible " />
      </MotionContent> */}
      <Capabilities simplified />
      {/* <DefisReleves /> */}
      <LetsWork />
    </Page>
  )
}

export const cardColor = [
  { color: "#FFF" },
  { color: "#D1F8AB" },
  { color: "#EB7F45" },
  { color: "#74AFD9" }
];



export default Expertise

